<template>
	<div>
		<s-crud
			title="Producto terminado por túnel de congelamiento"
			:config="config"
			:filter="filter"
			add
			edit 	
            remove
            addNoFunction
			search-input
            @rowSelected="rowSelected($event)"
            @add="openAddModal"
            @edit="openEditModal"
            ref="sCrudDiscardDevolution"
		>
            <template v-slot:options>
                <v-btn
                    color="orange darken-3"
                    dark
                    depressed
                    @click="showDefectLoteModal = true"
                    class="mx-2"
                >
                    <v-icon left>mdi-alert-decagram</v-icon>
                    Prorrateo Defectos Lote
                </v-btn>
            </template>
            <template v-slot="props">
                <div class="text-center pa-4">
                    <v-icon size="64" color="grey lighten-2">mdi-table</v-icon>
                    <p class="mt-2">Selecciona un registro para editar o agrega uno nuevo</p>
                </div>
            </template>
		</s-crud>

        <!-- Modal para AGREGAR nuevo registro -->
        <v-dialog v-model="showAddModal" max-width="1200px" persistent>
            <v-card class="modern-modal" elevation="24">
                <!-- Header con gradiente y mejor jerarquía -->
                <div class="modal-header">
                    <div class="header-content">
                        <div class="header-icon">
                            <v-icon size="28" color="white">mdi-plus-circle</v-icon>
                        </div>
                        <div class="header-text">
                            <h2 class="modal-title">Nuevo Registro de Prodcuto terminado</h2>
                            <p class="modal-subtitle">Complete la información para registrar una nueva cantidad de Prodcuto terminado</p>
                        </div>
                    </div>
                    <v-btn 
                        icon 
                        @click="closeAddModal" 
                        class="close-btn"
                        color="white"
                        elevation="0"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-card-text class="modal-body">
                    <!-- Stepper visual para mejor UX -->
                    <div class="progress-steps mb-8 mt-2">
                        <div class="step" :class="{ active: true, completed: addForm.TypeCultive }">
                            <div class="step-circle">
                                <v-icon v-if="addForm.TypeCultive" color="white" size="16">mdi-check</v-icon>
                                <span v-else>1</span>
                            </div>
                            <span class="step-label">Cultivo y Periodo</span>
                        </div>
                        <div class="step-divider"></div>
                        <div class="step" :class="{ active: addForm.TypeCultive, completed: addForm.selectedPeriod }">
                            <div class="step-circle">
                                <v-icon v-if="addForm.selectedPeriod" color="white" size="16">mdi-check</v-icon>
                                <span v-else>2</span>
                            </div>
                            <span class="step-label">Configuración</span>
                        </div>
                        <div class="step-divider"></div>
                        <div class="step" :class="{ active: addForm.selectedPeriod && addForm.itemsDefects.length > 0 }">
                            <div class="step-circle">
                                <span>3</span>
                            </div>
                            <span class="step-label">Registro de Producto terminado</span>
                        </div>
                    </div>

                    <!-- Sección 1: Selección de Cultivo y Periodo -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <v-icon color="primary">mdi-sprout</v-icon>
                            </div>
                            <div>
                                <h3 class="section-title">Selección de Cultivo y Periodo</h3>
                                <p class="section-description">Seleccione el cultivo, línea y periodo a registrar</p>
                            </div>
                        </div>
                        
                        <v-card class="form-card" elevation="2">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <div class="input-group">
                                            <s-select-definition
                                                :def="1173"
                                                v-model="addForm.TypeCultive"
                                                @input="onAddCultiveChange($event)"
                                                outlined
                                                dense
                                                hide-details="auto"
                                            ></s-select-definition>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <div class="input-group">
                                            <s-select
                                                :items="ProductionCategory"
                                                item-value="CecID"
                                                item-text="CecDescription"
                                                v-model="addForm.CecID"
                                                @input="onAddTunnelChange($event)"
                                                clearable
                                                outlined
                                                dense
                                                hide-details="auto"
                                                :disabled="!addForm.TypeCultive"
                                                label="Túnel"
                                            ></s-select>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="4" v-if="addForm.CecID > 0">
                                        <div class="input-group">
                                            <s-select
                                                :items="addForm.itemsDataCli"
                                                item-value="PchID"
                                                item-text="displayText"
                                                v-model="addForm.PchID"
                                                @input="onAddPeriodChange($event)"
                                                clearable
                                                outlined
                                                dense
                                                hide-details="auto"
                                                label="Periodo"
                                            ></s-select>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </div>

                    <div class="form-section progress-steps mb-0" v-if="addForm.PchID > 0 && (addForm.validateWeight === null || addForm.validateWeight <= 0)">
                        <div class="section-header">
                            <div class="section-icon alert-icon">
                                <v-icon color="error">mdi-alert</v-icon>
                            </div>
                            <div>
                                <h3 class="section-title">Alerta de Peso</h3>
                                <p class="section-description">Se requiere verificar el peso del periodo</p>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <!-- Nueva Sección Superior: Datos de Líneas -->
                        <div class="form-section" v-if="addForm.selectedPeriod && (addForm.validateWeight !== null || addForm.validateWeight > 0)">
                            <div class="section-header">
                                <div class="section-icon">
                                    <v-icon color="primary">mdi-format-line-spacing</v-icon>
                                </div>
                                <div>
                                    <h3 class="section-title">Datos de Líneas</h3>
                                    <p class="section-description">Información de las líneas y tiempos del periodo seleccionado</p>
                                </div>
                            </div>
                            
                            <v-card class="info-card" elevation="2">
                                <v-card-text>
                                    <div v-for="(line, index) in addForm.selectedPeriod.LinesDetails" :key="index">
                                         <v-row>
                                             <v-col cols="12" md="6" lg="3">
                                                 <div class="info-item">
                                                     <div class="info-value">
                                                         <s-text
                                                             v-model="line.LineName"
                                                             readonly
                                                             outlined
                                                             dense
                                                             hide-details
                                                             label="Línea de Producción"
                                                         ></s-text>
                                                     </div>
                                                 </div>
                                             </v-col>
                                             <v-col cols="12" md="6" lg="3">
                                                 <div class="info-item">
                                                     <div class="info-value">
                                                         <s-text
                                                             v-model="line.CutType"
                                                             readonly
                                                             outlined
                                                             dense
                                                             hide-details
                                                             label="Tipo Corte"
                                                         ></s-text>
                                                     </div>
                                                 </div>
                                             </v-col>
                                             <v-col cols="12" md="6" lg="3">
                                                 <div class="info-item">
                                                     <div class="info-value">
                                                         <s-text
                                                             type="time"
                                                             v-model="line.StartTime"
                                                             readonly
                                                             outlined
                                                             dense
                                                             hide-details
                                                             label="Hora Inicio"
                                                         ></s-text>
                                                     </div>
                                                 </div>
                                             </v-col>
                                             <v-col cols="12" md="6" lg="3">
                                                 <div class="info-item">
                                                     <div class="info-value">
                                                         <s-text
                                                             type="time"
                                                             v-model="line.EndTime"
                                                             readonly
                                                             outlined
                                                             dense
                                                             hide-details
                                                             label="Hora Fin"
                                                         ></s-text>
                                                     </div>
                                                 </div>
                                             </v-col>
                                         </v-row>
                                         <v-divider v-if="index < addForm.selectedPeriod.LinesDetails.length - 1" class="my-4"></v-divider>
                                     </div>
                                </v-card-text>
                            </v-card>
                        </div>

                        <!-- Sección 2: Configuración del Periodo -->
                        <div class="form-section" v-if="addForm.selectedPeriod && (addForm.validateWeight !== null || addForm.validateWeight > 0)">
                            <div class="section-header">
                                <div class="section-icon">
                                    <v-icon color="info">mdi-cog</v-icon>
                                </div>
                                <div>
                                    <h3 class="section-title">Configuración del Periodo</h3>
                                    <p class="section-description">Balances de peso del producto terminado</p>
                                </div>
                            </div>
                            
                            <v-card class="info-card" elevation="2">
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <div class="info-value">
                                                    <s-text
                                                        type="decimal"
                                                        v-model="addForm.PcsPpa"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        label="PT A° (kg)"
                                                        @input="calculateTotal"
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <div class="info-value">
                                                    <s-text
                                                        type="decimal"
                                                        v-model="addForm.PcsPpb"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        label="PT B° (kg)"
                                                        @input="calculateTotal"
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <div class="info-value">
                                                    <s-text
                                                        type="decimal"
                                                        v-model="addForm.PcsTotal"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                        label="Total PT (kg)"
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <div class="info-value">
                                                    <s-text
                                                        type="decimal"
                                                        v-model="addForm.PcsOil"
                                                        outlined
                                                        dense
                                                        hide-details
                                                        label="PT Aceite (Kg)"
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </div>

                        <!-- Sección 3: Registro de Defectos -->
                        <div class="form-section" v-if="addForm.selectedPeriod && addForm.itemsDefects.length > 0 && addForm.validateWeight !== null || addForm.validateWeight > 0">
                            <div class="section-header">
                                <div class="section-icon">
                                    <v-icon color="warning">mdi-alert-circle</v-icon>
                                </div>
                                <div>
                                    <h3 class="section-title">Registro de Defectos</h3>
                                    <p class="section-description">Registre los defectos encontrados por lote</p>
                                </div>
                            </div>

                            <v-row>
                                <!-- Panel de entrada de defectos -->
                                <v-col md="6">
                                    <v-card class="defect-input-card" elevation="2">
                                        <v-card-title class="defect-card-title">
                                            <v-icon left color="primary">mdi-plus-box</v-icon>
                                            Nuevo Lote
                                        </v-card-title>
                                        <v-card-text>
                                            <!-- Selección de lote -->
                                            <div class="lote-selector mb-6">
                                                <v-row align="center">
                                                    <v-col cols="12" md="8">
                                                        <div class="input-group">
                                                            <label class="input-label">Número de Lote</label>
                                                            <s-select
                                                                :items="availableLotesAdd"
                                                                item-value="RcfID"
                                                                item-text="RcfDate"
                                                                v-model="addForm.selectedLoteID"
                                                                clearable
                                                                outlined
                                                                dense
                                                                hide-details="auto"
                                                            ></s-select>
                                                        </div>
                                                    </v-col>
                                                    <!-- align-self="center" -->
                                                    <v-col cols="12" md="4"> 
                                                        <v-btn
                                                            color="primary"
                                                            @click="addLoteWithDefects"
                                                            :disabled="!canAddLote"
                                                            block
                                                            depressed
                                                            class="add-lote-btn mt-4"
                                                        >
                                                            <v-icon left size="20">mdi-plus</v-icon>
                                                            Agregar
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </div>

                                            <!-- Lista de defectos -->
                                            <div class="defects-list">
                                                <h4 class="defects-title">Defectos a Registrar</h4>
                                                <div class="defects-grid">
                                                    <div 
                                                        v-for="(defect, index) in addForm.itemsDefects"
                                                        :key="defect.DfpID"
                                                        class="defect-item"
                                                    >
                                                        <div class="defect-info">
                                                            <v-icon size="16" color="orange" class="mr-2">mdi-alert-circle-outline</v-icon>
                                                            <span class="defect-name">{{ defect.DfpName }}</span>
                                                        </div>
                                                        <div class="defect-input">
                                                            <s-text
                                                                type="decimal"
                                                                v-model="addForm.defectWeights[defect.DfpID]"
                                                                :step="0.01"
                                                                :min="-1"
                                                                suffix="kg"
                                                                outlined
                                                                dense
                                                                hide-details
                                                                :ref="'defectInput' + index"
                                                                @keyupEnter="focusNextDefectInput(index)"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <!-- Panel de lotes registrados -->
                                <v-col md="6">
                                    <v-card class="registered-lotes-card" elevation="2">
                                        <v-card-title class="registered-card-title">
                                            <v-icon left color="success">mdi-check-circle</v-icon>
                                            Lotes Registrados
                                            <v-spacer></v-spacer>
                                            <v-chip 
                                                v-if="addForm.loteDetails.length > 0"
                                                color="success"
                                                small
                                                outlined
                                            >
                                                {{ addForm.loteDetails.length }} lote(s)
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <div v-if="addForm.loteDetails.length > 0" class="lotes-table">
                                                <v-data-table
                                                    :headers="headersDefectDetails"
                                                    :items="addForm.loteDetails"
                                                    :items-per-page="5"
                                                    hide-default-footer
                                                    class="modern-table"
                                                >
                                                    <template v-slot:item.actions="{ item }">
                                                        <div class="table-actions">
                                                            <v-btn
                                                                color="info"
                                                                icon
                                                                small
                                                                @click="viewLoteDefects(item)"
                                                                class="mr-1"
                                                            >
                                                                <v-icon size="18">mdi-eye</v-icon>
                                                            </v-btn>
                                                            <v-btn
                                                                color="error"
                                                                icon
                                                                small
                                                                @click="removeLoteDetail(item, 'add')"
                                                            >
                                                                <v-icon size="18">mdi-delete</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                            </div>
                                            <div v-else class="empty-state">
                                                <div class="empty-icon">
                                                    <v-icon size="64" color="grey lighten-2">mdi-package-variant</v-icon>
                                                </div>
                                                <div class="empty-title">No hay lotes registrados</div>
                                                <div class="empty-description">
                                                    Seleccione un lote y registre los defectos para comenzar
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-card-text>

                <!-- Footer con botones mejorados -->
                <v-card-actions class="modal-footer">
                    <div class="footer-content">
                        <v-btn
                            color="grey"
                            text
                            @click="closeAddModal"
                            class="cancel-btn"
                        >
                            <v-icon left size="20">mdi-close</v-icon>
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="saveRecord"
                            :disabled="!addForm.TypeCultive || !addForm.PchID"
                            depressed
                            class="save-btn"
                        >
                            <v-icon left size="20">mdi-content-save</v-icon>
                            Guardar Registro
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para EDITAR registro existente -->
        <v-dialog v-model="showEditModal" max-width="1400px" persistent>
            <v-card class="modern-modal" elevation="24">
                <!-- Header con gradiente y mejor jerarquía -->
                <div class="modal-header">
                    <div class="header-content">
                        <div class="header-icon">
                            <v-icon size="28" color="white">mdi-pencil-circle</v-icon>
                        </div>
                        <div class="header-text">
                            <h2 class="modal-title">Editar Registro de Prodcuto terminado</h2>
                            <p class="modal-subtitle">ID: {{ itemSelected?.PcsID }} - Modificar información del producto terminado</p>
                        </div>
                    </div>
                    <v-btn 
                        icon 
                        @click="closeEditModal" 
                        class="close-btn"
                        color="white"
                        elevation="0"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-card-text class="modal-body">
                    <!-- Stepper visual para mejor UX -->
                    <div class="progress-steps mb-8 mt-2">
                        <div class="step active completed">
                            <div class="step-circle">
                                <v-icon color="white" size="16">mdi-check</v-icon>
                            </div>
                            <span class="step-label">Información Base</span>
                        </div>
                        <div class="step-divider"></div>
                        <div class="step active completed">
                            <div class="step-circle">
                                <v-icon color="white" size="16">mdi-check</v-icon>
                            </div>
                            <span class="step-label">PT Existentes</span>
                        </div>
                        <div class="step-divider"></div>
                        <div class="step active">
                            <div class="step-circle">
                                <span>3</span>
                            </div>
                            <span class="step-label">Modificaciones</span>
                        </div>
                    </div>

                    <!-- Nueva Sección Superior: Datos de Líneas -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <v-icon color="primary">mdi-format-line-spacing</v-icon>
                            </div>
                            <div>
                                <h3 class="section-title">Datos de Líneas</h3>
                                <p class="section-description">Información de las líneas y tiempos del periodo seleccionado (solo lectura)</p>
                            </div>
                        </div>
                        
                        <v-card class="info-card" elevation="2">
                            <v-card-text>
                                <v-row class="mb-4">
                                    <v-col cols="12" md="6" lg="6">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-sprout</v-icon>
                                                Tipo Cultivo
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    v-model="editForm.TypeCultiveName"
                                                    readonly
                                                    outlined
                                                    dense
                                                    hide-details
                                                ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="6">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-snowflake</v-icon>
                                                Salida Congelamiento
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    v-model="editForm.CecName"
                                                    readonly
                                                    outlined
                                                    dense
                                                    hide-details
                                                ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                                
                                <v-divider class="mb-4"></v-divider>
                                
                                <div v-for="(line, index) in editForm.LinesDetails" :key="index">
                                    <v-row>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <label class="info-label">
                                                    <v-icon size="16" color="success" class="mr-2">mdi-format-line-spacing</v-icon>
                                                    Línea de Producción
                                                </label>
                                                <div class="info-value">
                                                    <s-text
                                                        v-model="line.LineName"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <label class="info-label">
                                                    <v-icon size="16" color="success" class="mr-2">mdi-content-cut</v-icon>
                                                    Tipo Corte
                                                </label>
                                                <div class="info-value">
                                                    <s-text
                                                        v-model="line.CutType"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <label class="info-label">
                                                    <v-icon size="16" color="success" class="mr-2">mdi-clock-start</v-icon>
                                                    Hora Inicio
                                                </label>
                                                <div class="info-value">
                                                    <s-text
                                                        v-model="line.StartTime"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6" lg="3">
                                            <div class="info-item">
                                                <label class="info-label">
                                                    <v-icon size="16" color="success" class="mr-2">mdi-clock-end</v-icon>
                                                    Hora Fin
                                                </label>
                                                <div class="info-value">
                                                    <s-text
                                                        v-model="line.EndTime"
                                                        readonly
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></s-text>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-divider v-if="index < editForm.LinesDetails.length - 1" class="my-4"></v-divider>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>

                    <!-- Sección 2: Configuración del Periodo -->
                    <div class="form-section">
                        <div class="section-header">
                            <div class="section-icon">
                                <v-icon color="info">mdi-cog</v-icon>
                            </div>
                            <div>
                                <h3 class="section-title">Configuración del Periodo</h3>
                                <p class="section-description">Balances de peso del producto terminado</p>
                            </div>
                        </div>
                        
                        <v-card class="info-card" elevation="2">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" md="6" lg="3">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-alpha</v-icon>
                                                PT A° (kg)
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    type="decimal"
                                                    v-model="editForm.PcsPpa"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    @input="calculateTotalEdit"
                                                 ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="3">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-alpha</v-icon>
                                                PT B° (kg)
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    type="decimal"
                                                    v-model="editForm.PcsPpb"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    @input="calculateTotalEdit"
                                                ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="3">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-alpha</v-icon>
                                                Total PT (kg)
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    type="decimal"
                                                    v-model="editForm.PcsTotal"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    readonly
                                                ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="6" lg="3">
                                        <div class="info-item">
                                            <label class="info-label">
                                                <v-icon size="16" color="success" class="mr-2">mdi-alpha</v-icon>
                                                PT Aceite (Kg)
                                            </label>
                                            <div class="info-value">
                                                <s-text
                                                    type="decimal"
                                                    v-model="editForm.PcsOil"
                                                    outlined
                                                    dense
                                                    hide-details
                                                ></s-text>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </div>

                    <v-row>
                        <v-col md="6">
                        <!-- Sección 3: Agregar Más Lotes -->
                            <div class="form-section">
                                <div class="section-header">
                                    <div class="section-icon">
                                        <v-icon color="info">mdi-plus-circle</v-icon>
                                    </div>
                                    <div>
                                        <h3 class="section-title">Agregar Más Lotes</h3>
                                        <p class="section-description">Opcional: Añadir lotes adicionales al registro</p>
                                    </div>
                                </div>

                                <v-row>
                                    <!-- Panel de entrada de defectos -->
                                    <v-col cols="12" lg="12">
                                        <v-card class="defect-input-card" elevation="2">
                                            <v-card-title class="defect-card-title">
                                                <v-icon left color="primary">mdi-plus-box</v-icon>
                                                Nuevo Lote
                                            </v-card-title>
                                            <v-card-text>
                                                <!-- Selección de lote -->
                                                <div class="lote-selector mb-6">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="8">
                                                            <div class="input-group">
                                                                <label class="input-label">Número de Lote</label>
                                                                <s-select
                                                                    :items="availableLotesEdit"
                                                                    item-value="RcfID"
                                                                    item-text="RcfDate"
                                                                    v-model="editForm.selectedLoteID"
                                                                    clearable
                                                                    outlined
                                                                    dense
                                                                    hide-details="auto"
                                                                ></s-select>
                                                            </div>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <v-btn
                                                                color="primary"
                                                                @click="addLoteWithDefectsToEdit"
                                                                :disabled="!canAddLoteToEdit"
                                                                block
                                                                depressed
                                                                class="add-lote-btn mt-4"
                                                            >
                                                                <v-icon left size="20">mdi-plus</v-icon>
                                                                Agregar
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </div>

                                                <!-- Lista de defectos -->
                                                <div class="defects-list" v-if="editForm.itemsDefects && editForm.itemsDefects.length > 0">
                                                    <h4 class="defects-title">Defectos a Registrar</h4>
                                                    <div class="defects-grid">
                                                        <div 
                                                            v-for="(defect, index) in editForm.itemsDefects"
                                                            :key="defect.DfpID"
                                                            class="defect-item"
                                                        >
                                                            <div class="defect-info">
                                                                <v-icon size="16" color="orange" class="mr-2">mdi-alert-circle-outline</v-icon>
                                                                <span class="defect-name">{{ defect.DfpName }}</span>
                                                            </div>
                                                            <div class="defect-input">
                                                                <s-text
                                                                    type="decimal"
                                                                    v-model="editForm.defectWeights[defect.DfpID]"
                                                                    :step="0.01"
                                                                    :min="-1"
                                                                    suffix="kg"
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    :ref="'defectInput' + index"
                                                                    @keyupEnter="focusNextDefectInput(index)"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                        <v-col md="6">
                            <div class="form-section" v-if="editForm.loteDetails.length > 0">
                                <div class="section-header">
                                    <div class="section-icon">
                                        <v-icon color="warning">mdi-alert-circle</v-icon>
                                    </div>
                                    <div>
                                        <h3 class="section-title">Lotes y Defectos Registrados</h3>
                                        <p class="section-description">Defectos actualmente registrados en el sistema</p>
                                    </div>
                                </div>
                                
                                <v-card class="registered-lotes-card" elevation="2">
                                    <v-card-title class="registered-card-title">
                                        <v-icon left color="warning">mdi-package-variant</v-icon>
                                        Lotes Registrados
                                        <v-spacer></v-spacer>
                                        <v-chip 
                                            color="warning"
                                            small
                                            outlined
                                        >
                                            {{ editForm.loteDetails.length }} lote(s)
                                        </v-chip>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-data-table
                                            :headers="headersDefectDetails"
                                            :items="editForm.loteDetails"
                                            :items-per-page="10"
                                            class="modern-table elevation-0"
                                        >
                                            <template v-slot:item.actions="{ item }">
                                                <div class="table-actions">
                                                    <v-btn
                                                        color="info"
                                                        icon
                                                        small
                                                        @click="viewLoteDefects(item)"
                                                        class="mr-1"
                                                    >
                                                        <v-icon size="18">mdi-eye</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="error"
                                                        icon
                                                        small
                                                        @click="removeLoteDetail(item, 'edit')"
                                                    >
                                                        <v-icon size="18">mdi-delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>

                <!-- Footer con botones mejorados -->
                <v-card-actions class="modal-footer">
                    <div class="footer-content">
                        <v-btn
                            color="grey"
                            text
                            @click="closeEditModal"
                            class="cancel-btn"
                        >
                            <v-icon left size="20">mdi-close</v-icon>
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="updateRecord"
                            depressed
                            class="save-btn"
                        >
                            <v-icon left size="20">mdi-content-save</v-icon>
                            Actualizar Registro
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para ver defectos del lote -->
        <v-dialog v-model="showDefectsModal" max-width="800px">
            <v-card>
                <v-card-title>
                    Defectos del Lote: {{ selectedLoteForModal ? selectedLoteForModal.loteName : '' }}
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="[
                            { text: 'Defecto', value: 'DfpName' },
                            { text: 'Peso (kg)', value: 'PsdWeight' },
                            { text: 'Acciones', value: 'actions', sortable: false }
                        ]"
                        :items="selectedLoteForModal ? selectedLoteForModal.defects : []"
                        hide-default-footer
                        dense
                    >
                        <template v-slot:item.actions="{ item }">
                            <v-btn
                                color="error"
                                icon
                                small
                                @click="removeDefectFromLote(item)"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="showDefectsModal = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Componente de Registro y Prorrateo de Defectos por Lote -->
        <frz-defect-lote-registration-panel 
            v-model="showDefectLoteModal"
            @saved="refreshTableData"
        />
	</div>
</template>

<script>
import FrzDefectLoteRegistrationPanel from "./components/FrzDefectLoteRegistrationPanel.vue";
import _sDamageFlawCultiveService from "@/services/FrozenProduction/DamageFlawCultiveService";
import _sProcessSampling from '@/services/FrozenProduction/ProcessSamplingService';
import _sTurnService from "@/services/FreshProduction/PrfTurnService";
import _sFrzCtnLinesProcessService from "@/services/FrozenProduction/FrzCtnLinesProcess.js"
import _sProductionCategory from '@/services/FrozenProduction/ProductionCategory.js';
import _sFrzDefectsProcessService from "@/services/FrozenProduction/FrzDefectsProcessService.js";

export default {
    components: {
        FrzDefectLoteRegistrationPanel
    },
    data: () => ({
        showDefectLoteModal: false,
        itemRcfid: [],
        filter: {
            DateBegin: null,
            DateEnd: null,
            TurnID: null,
            TrnID: null,
        },
        items: [],
        DamageCultive: [],
        itemSelected: null,
        config: {
            model: {
                PcsID: "ID",
            },
            service: _sProcessSampling,
            headers: [
                { text: "ID", value: "PcsID" },
                { text: "Producto", value: "TypeCultiveName" },
                { text: "Túnel", value: "CecName" },
                { text: "Periodo", value: "PchPeriodo" },
                { text: "Tipo de corte", value: "TypeCutName" },
                { text: "Cliente", value: "CumNombre" },
                { text: "Tipo de cultivo", value: "TypeCropName" },
                { text: "PT A°", value: "PcsPpa" },
                { text: "PT B°", value: "PcsPpb" },
                { text: "Aceite", value: "PcsOil" },
            ]
        },
        Turn: "",
        ProductionCategory: [],
        
        showAddModal: false,
        showEditModal: false,
        showDefectsModal: false,
        selectedLoteForModal: null,
        
        addForm: {
            TypeCultive: 0,
            ClpID: 0,
            CecID: 0,
            PchID: 0,
            selectedPeriod: null,
            itemsLineas: [],
            itemsDataCli: [],
            itemRcfid: [],
            itemsDefects: [],
            selectedLoteID: null,
            defectWeights: {},
            loteDetails: [],
            PcsPpa: 0,
            PcsPpb: 0,
            PcsTotal: 0,
            PcsOil: 0,
        },
        
        // Formulario para EDITAR
        editForm: {
            PcsID: null,
            TypeCultive: 0,
            TypeCultiveName: '',
            ClpID: 0,
            CecID: 0,
            LncDescription: '',
            CecName: '',
            TypeCutName: '',
            PcsTimeBegin: '',
            PcsTimeEnd: '',
            itemRcfid: [],
            itemsDefects: [],
            selectedLoteID: null,
            defectWeights: {},
            loteDetails: [],
            PcsPpa: 0,
            PcsPpb: 0,
            PcsTotal: 0,
            PcsOil: 0
        },
        
        // Headers para tabla de detalles
        headersDefectDetails: [
            { text: "Lote", value: "loteName" },
            { text: "Cantidad de Defectos", value: "defectCount" },
            { text: "Peso Total", value: "totalWeight" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        deletedLotes: [],
        deletedDefects: [],
    }),
    
    computed: {
        canAddLote() {
            return this.addForm.selectedLoteID && this.hasDefectsWithWeightAdd;
        },
        hasDefectsWithWeightAdd() {
            return Object.values(this.addForm.defectWeights).some(PsdWeight => PsdWeight && PsdWeight >= 0);
        },
        canAddLoteToEdit() {
            return this.editForm.selectedLoteID && this.hasDefectsWithWeightEdit;
        },
        hasDefectsWithWeightEdit() {
            return Object.values(this.editForm.defectWeights).some(PsdWeight => PsdWeight && PsdWeight > 0);
        },
        availableLotesAdd() {
            if (!this.addForm.itemRcfid) return [];
            
            const usedLoteIDs = this.addForm.loteDetails.map(lote => lote.RcfID);
            return this.addForm.itemRcfid.filter(lote => !usedLoteIDs.includes(lote.RcfID));
        },
        availableLotesEdit() {
            if (!this.editForm.itemRcfid) return [];
            
            const usedLoteIDs = this.editForm.loteDetails.map(lote => lote.RcfID);
            return this.editForm.itemRcfid.filter(lote => !usedLoteIDs.includes(lote.RcfID));
        }
    },
    
    methods: {
        refreshTableData() {
            if (this.$refs.sCrudDiscardDevolution) {
                this.$refs.sCrudDiscardDevolution.refresh();
            }
        },
        rowSelected(item) {
            if (item && item.length > 0) {
                this.itemSelected = item[0];
                // console.log("Registro seleccionado:", this.itemSelected);
            } else {
                this.itemSelected = null;
            }
        },
        
        openAddModal() {
            this.resetAddForm();
            this.inputProdCategory();
            this.showAddModal = true;
        },
        
        // Cerrar modal de agregar
        closeAddModal() {
            this.showAddModal = false;
            this.resetAddForm();
        },
        
        // Abrir modal para editar
        openEditModal() {
            if (!this.itemSelected) {
                this.$fun.alert("Debe seleccionar un registro para editar", "warning");
                return;
            }
            
            this.loadEditData();
            this.deletedLotes = [];
            this.deletedDefects = [];
            this.showEditModal = true;
        },
        
        closeEditModal() {
            this.showEditModal = false;
            this.deletedLotes = [];
            this.deletedDefects = [];
            this.resetEditForm();
        },
        
        resetAddForm() {
            this.addForm = {
                TypeCultive: 0,
                ClpID: 0,
                CecID: 0,
                PchID: 0,
                selectedPeriod: null,
                itemsLineas: [],
                itemsDataCli: [],
                itemRcfid: [],
                itemsDefects: [],
                selectedLoteID: null,
                defectWeights: {},
                loteDetails: [],
                PcsPpa: 0,
                PcsPpb: 0,
                PcsTotal: 0,
                PcsOil: 0,
                validateWeight: null
            };
        },
        
        resetEditForm() {
            this.editForm = {
                PcsID: null,
                TypeCultive: 0,
                TypeCultiveName: '',
                ClpID: 0,
                CecID: 0,
                LncDescription: '',
                CecName: '',
                TypeCutName: '',
                PcsTimeBegin: '',
                PcsTimeEnd: '',
                itemRcfid: [],
                itemsDefects: [],
                selectedLoteID: null,
                defectWeights: {},
                loteDetails: [],
                PcsPpa: 0,
                PcsPpb: 0,
                PcsTotal: 0,
                PcsOil: 0,
                validateWeight: null,
                LinesDetails: []
            };
        },
        
        async loadEditData() {
            if (!this.itemSelected) return;
            
            try {
                // Cargar información básica del registro
                this.editForm.PcsID = this.itemSelected.PcsID;
                this.editForm.TypeCultive = this.itemSelected.TypeCultive;
                this.editForm.TypeCultiveName = this.itemSelected.TypeCultiveName;
                this.editForm.ClpID = this.itemSelected.ClpID;
                this.editForm.CecID = this.itemSelected.CecID;
                this.editForm.LncDescription = this.itemSelected.LncDescription;
                this.editForm.CecName = this.itemSelected.CecName;
                this.editForm.TypeCutName = this.itemSelected.TypeCutName;
                this.editForm.PcsTimeBegin = this.itemSelected.PcsTimeBegin;
                this.editForm.PcsTimeEnd = this.itemSelected.PcsTimeEnd;
                this.editForm.PcsPpa = this.itemSelected.PcsPpa;
                this.editForm.PcsPpb = this.itemSelected.PcsPpb;
                this.editForm.PcsOil = this.itemSelected.PcsOil;
  
                this.editForm.PcsTotal = this.editForm.PcsPpa + this.editForm.PcsPpb;
                this.editForm.validateWeight = 
                    (parseFloat(this.itemSelected.PeriodWeightDifference) || 0) +
                    (parseFloat(this.itemSelected.TotalDefectsWeight) || 0);
                
                // Cargar detalles del registro (lotes y defectos)
                await this.loadEditDetails();
                
                // Cargar opciones para agregar más lotes
                await this.loadEditOptions();

                // Cargar datos desglosados de líneas
                let obj = {
                    ClpID: this.editForm.ClpID || 0,
                    CecID: this.editForm.CecID || 0,
                    TurnID: this.Turn[0]?.TrnID || null
                };
                _sProcessSampling.listPeriod(obj, this.$fun.getUserID()).then(r => {
                    if (r.status === 200 && r.data) {
                        const matchedPeriod = r.data.find(x => x.PchPeriodo === this.itemSelected.PchPeriodo);
                        if (matchedPeriod && matchedPeriod.LinesDetails) {
                            this.$set(this.editForm, 'LinesDetails', matchedPeriod.LinesDetails);
                        } else {
                            this.$set(this.editForm, 'LinesDetails', [
                                {
                                    LineName: this.editForm.LncDescription,
                                    CutType: this.editForm.TypeCutName,
                                    StartTime: this.editForm.PcsTimeBegin,
                                    EndTime: this.editForm.PcsTimeEnd
                                }
                            ]);
                        }
                    }
                }).catch(err => {
                    console.error("Error loading period line details:", err);
                    this.$set(this.editForm, 'LinesDetails', [
                        {
                            LineName: this.editForm.LncDescription,
                            CutType: this.editForm.TypeCutName,
                            StartTime: this.editForm.PcsTimeBegin,
                            EndTime: this.editForm.PcsTimeEnd
                        }
                    ]);
                });
                
            } catch (error) {
                console.error("Error cargando datos de edición:", error);
                this.$fun.alert("Error al cargar los datos del registro", "error");
            }
        },
        
        async loadEditDetails() {
            try {
                const response = await _sProcessSampling.listdetail(this.itemSelected, this.$fun.getUserID());
                
                if (response.status === 200) {
                    // console.log("Detalles cargados:", response.data);
                    this.editForm.loteDetails = response.data.map(detail => ({
                        id: detail.PsgID,
                        RcfID: detail.RcfID,
                        loteName: detail.RcfDate,
                        defects: detail.FrzProcessSamplingDefects || [],
                        defectCount: detail.FrzProcessSamplingDefects ? detail.FrzProcessSamplingDefects.length : 0,
                        totalWeight: detail.PsgTotalWeight,
                        PchID: detail.PchID,
                        TypeCultive: detail.TypeCultive,
                        SecStatus: detail.SecStatus
                    }));
                }
            } catch (error) {
                console.error("Error cargando detalles:", error);
            }
        },
        
        async loadEditOptions() {
            try {
                // Cargar lotes disponibles
                const filter = {
                    ClpID: 0,
                    CecID: this.editForm.CecID,
                    TurnID: this.itemSelected.TurnID || this.Turn[0]?.TrnID || null,
                    PchID: this.itemSelected.PchID
                };
                
                const lotsResponse = await _sProcessSampling.lst(filter, this.$fun.getUserID());
                if (lotsResponse.status === 200) {
                    this.editForm.itemRcfid = lotsResponse.data;
                }
                
                const defectsData = {
                    TypeCultive: this.editForm.TypeCultive,
                    TypeCut: this.itemSelected.TypeCut
                };
                
                const defectsResponse = await _sFrzDefectsProcessService.list(defectsData, this.$fun.getUserID());
                if (defectsResponse.status === 200) {
                    this.editForm.itemsDefects = defectsResponse.data;
                }
                
            } catch (error) {
                console.error("Error cargando opciones:", error);
            }
        },
        
        // Eventos para el formulario de AGREGAR
        onAddCultiveChange(value) {
            this.addForm.TypeCultive = value;
            this.getAddLines(value);
        },
        
        onAddTunnelChange(value) {
            this.addForm.CecID = value;
            this.listAddConfHour(value);
        },
        
        onAddPeriodChange(value) {
            this.addForm.PchID = value;
            this.addForm.validateWeight = null;
            const item = this.addForm.itemsDataCli.find(x => x.PchID === value);
            this.addForm.validateWeight = item ? item.SAverageWeightJabaN : null;

            if(this.addForm.validateWeight != null || this.addForm.validateWeight > 0) {
                this.getAddPeriod(value);
            }
        },
        
        getAddLines(item) {
            if (item > 0) {
                _sDamageFlawCultiveService.list({ TypeCultive: item }, this.$fun.getUserID()).then(r => {
                    if (r.status == 200) {
                        this.DamageCultive = r.data;
                    }
                });
            }
            
            // Reset valores dependientes
            this.addForm.ClpID = 0;
            this.addForm.CecID = 0;
            this.addForm.PchID = 0;
            this.addForm.PcsPpa = 0;
            this.addForm.PcsPpb = 0;
            this.addForm.PcsOil = 0;
            this.addForm.PcsTotal = 0;
            this.addForm.selectedPeriod = null;
            this.addForm.itemsDataCli = [];
            this.addForm.itemRcfid = [];
            this.addForm.loteDetails = [];
            this.addForm.validateWeight = null;
        },
        
        listAddConfHour(item) {
            let obj = {
                ClpID: 0,
                CecID: this.addForm.CecID,
                TurnID: this.Turn[0]?.TrnID || null
            };
            
            _sProcessSampling.listPeriod(obj, this.$fun.getUserID())
                .then((r) => {
                    if (r.status == 200) {
                        r.data.forEach((el, index) => {
                            el.Line = index + 1;
                        });
                        
                        this.addForm.itemsDataCli = r.data.filter(x => x.PchState == 2).map(item => ({
                            ...item,
                            displayText: [item.PchPeriodo, item.TypeCutName, item.CumNombre, item.TypeCropName].filter(Boolean).join(' - ')
                        }));
                    }
                });
            
            this.addForm.PchID = 0;
            this.addForm.PcsPpa = 0;
            this.addForm.PcsPpb = 0;
            this.addForm.PcsOil = 0;
            this.addForm.PcsTotal = 0;
            this.addForm.selectedPeriod = null;

            this.addForm.itemsDataCli = [];
            this.addForm.itemRcfid = [];
            this.addForm.loteDetails = [];
            this.addForm.validateWeight = null;
        },
        
        getAddPeriod(item) {
            this.addForm.selectedPeriod = this.addForm.itemsDataCli.find(x => x.PchID === item);
            
            if (this.addForm.selectedPeriod != null) {
                this.inputProdCategory();
                this.initializeAdd();
                
                let data = {
                    TypeCultive: this.addForm.TypeCultive,
                    TypeCut: this.addForm.selectedPeriod.TypeCut,
                };
                
                this.getAddDefects(data);
            }

            this.addForm.itemRcfid = [];
            this.addForm.loteDetails = [];
            
        },
        
        initializeAdd() {
            let filter = {
                ClpID: 0,
                CecID: this.addForm.CecID,
                TurnID: this.Turn[0]?.TrnID || null,
                PchID: this.addForm.PchID
            };
            
            _sProcessSampling.lst(filter, this.$fun.getUserID()).then(r => {
                if (r.status == 200) {
                    console.log("Lotes disponibles:", r.data);
                    this.addForm.itemRcfid = r.data;
                }
            });
        },
        
        getAddDefects(item) {
            _sFrzDefectsProcessService.list(item, this.$fun.getUserID()).then(r => {
                if (r.status == 200) {
                    this.addForm.itemsDefects = r.data;
                }
            });
        },
        
        addLoteWithDefects() {
            if (!this.canAddLote) return;
            
            // Verificar si el lote ya existe
            const existingLote = this.addForm.loteDetails.find(lot => lot.RcfID === this.addForm.selectedLoteID);
            if (existingLote) {
                this.$fun.alert("Este lote ya fue registrado", "warning");
                return;
            }
            
            // Crear defectos del lote
            const loteDefects = this.addForm.itemsDefects
                .filter(defect => this.addForm.defectWeights[defect.DfpID] && this.addForm.defectWeights[defect.DfpID] > 0)
                .map(defect => ({
                    DfpID: defect.DfpID,
                    DfpName: defect.DfpName,
                    PsdWeight: parseFloat(this.addForm.defectWeights[defect.DfpID])
                }));
            
            const totalWeight = loteDefects.reduce((sum, defect) => sum + defect.PsdWeight, 0);
            
            // Validar que el peso total no exceda el peso disponible
            if (!this.canAddMoreWeight(totalWeight)) {
                const availableWeight = this.getAvailableWeight();
                this.$fun.alert(`No se puede agregar este lote. Peso disponible: ${availableWeight.toFixed(2)} kg, Peso a agregar: ${totalWeight.toFixed(2)} kg`, "warning");
                return;
            }
            
            const selectedLote = this.addForm.itemRcfid.find(l => l.RcfID === this.addForm.selectedLoteID);
            
            const newLoteDetail = {
                id: Date.now(),
                RcfID: this.addForm.selectedLoteID,
                loteName: selectedLote ? selectedLote.RcfDate : 'N/A',
                defects: loteDefects,
                defectCount: loteDefects.length,
                totalWeight: totalWeight.toFixed(2),
                PchID: this.addForm.PchID,
                TypeCultive: this.addForm.TypeCultive
            };
            
            this.addForm.loteDetails.push(newLoteDetail);
            this.clearAddDefectWeights();
            this.addForm.selectedLoteID = null;
            
            this.$fun.alert("Lote agregado correctamente", "success");
        },
        
        // Agregar lote con defectos (para el modal de editar)
        addLoteWithDefectsToEdit() {
            if (!this.canAddLoteToEdit) return;
            
            // Verificar si el lote ya existe
            const existingLote = this.editForm.loteDetails.find(lot => lot.RcfID === this.editForm.selectedLoteID);
            if (existingLote) {
                this.$fun.alert("Este lote ya fue registrado", "warning");
                return;
            }
            
            // Crear defectos del lote
            const loteDefects = this.editForm.itemsDefects
                .filter(defect => this.editForm.defectWeights[defect.DfpID] && this.editForm.defectWeights[defect.DfpID] > 0)
                .map(defect => ({
                    DfpID: defect.DfpID,
                    DfpName: defect.DfpName,
                    PsdWeight: parseFloat(this.editForm.defectWeights[defect.DfpID])
                }));
            

            const totalWeight = loteDefects.reduce((sum, defect) => sum + defect.PsdWeight, 0);

            if (!this.canAddMoreWeightForEdit(totalWeight)) {
                // console.log("Peso total:", totalWeight);
                const availableWeight = this.getAvailableWeightForEdit();
                // console.log("Peso disponible:", availableWeight);
                this.$fun.alert(`No se puede agregar este lote. Peso disponible: ${availableWeight.toFixed(2)} kg, Peso a agregar: ${totalWeight.toFixed(2)} kg`, "warning");
                return;
            }

            const selectedLote = this.editForm.itemRcfid.find(l => l.RcfID === this.editForm.selectedLoteID);
            
            const newLoteDetail = {
                id: 0,
                RcfID: this.editForm.selectedLoteID,
                loteName: selectedLote ? selectedLote.RcfDate : 'N/A',
                defects: loteDefects,
                defectCount: loteDefects.length,
                totalWeight: totalWeight.toFixed(2),
                PchID: this.editForm.PchID || this.itemSelected.PchID,
                TypeCultive: this.editForm.TypeCultive
            };
            
            this.editForm.loteDetails.push(newLoteDetail);
            this.clearEditDefectWeights();
            this.editForm.selectedLoteID = null;
            
            this.$fun.alert("Lote agregado correctamente", "success");
        },
        
        clearAddDefectWeights() {
            this.addForm.defectWeights = {};
        },
        
        clearEditDefectWeights() {
            this.editForm.defectWeights = {};
        },
        
        viewLoteDefects(loteItem) {
            this.selectedLoteForModal = loteItem;
            // console.log("Lote seleccionado para ver defectos:", this.selectedLoteForModal);
            this.showDefectsModal = true;
        },
        restoreLoteToSelect(removedLote, mode) {
            const targetItemRcfid = mode === 'add' ? this.addForm.itemRcfid : this.editForm.itemRcfid;
            
            const existsInSelect = targetItemRcfid.some(item => item.RcfID === removedLote.RcfID);
            
            if (!existsInSelect) {
                const loteForSelect = {
                    RcfID: removedLote.RcfID,
                    RcfDate: removedLote.loteName,
                    PchID: removedLote.PchID,
                    TypeCultive: removedLote.TypeCultive
                };
                
                targetItemRcfid.push(loteForSelect);
                targetItemRcfid.sort((a, b) => a.RcfID - b.RcfID);
            }
        },
        removeLoteDetail(item, mode) {
            const targetArray = mode === 'add' ? this.addForm.loteDetails : this.editForm.loteDetails;
            const index = targetArray.findIndex(lot => lot.id === item.id);
            
            if (index !== -1) {
                const removedLote = targetArray.splice(index, 1)[0];
                
                if (mode === 'edit' && removedLote.id && removedLote.id > 0) {
                    // Marcar el lote como eliminado
                    removedLote.SecStatus = 0;
                    removedLote.UsrUpdateID = this.$fun.getUserID();
                    
                    // También marcar todos sus defectos como eliminados
                    if (removedLote.defects && removedLote.defects.length > 0) {
                        removedLote.defects.forEach(defect => {
                            if (defect.PsdID && defect.PsdID > 0) {
                                defect.SecStatus = 0;
                                defect.UsrUpdateID = this.$fun.getUserID();
                            }
                        });
                    }
                    
                    this.deletedLotes.push(removedLote);
                }
                this.restoreLoteToSelect(removedLote, mode);
                this.$fun.alert("Lote eliminado", "success");
            }
        },

        removeDefectFromLote(defectItem) {
            if (!this.selectedLoteForModal) return;
            
            const defectIndex = this.selectedLoteForModal.defects.findIndex(d => d.DfpID === defectItem.DfpID);
            if (defectIndex !== -1) {
                const removedDefect = this.selectedLoteForModal.defects.splice(defectIndex, 1)[0];
                
                // Marcar defecto como eliminado si tiene ID (existe en BD)
                if (removedDefect.PsdID && removedDefect.PsdID > 0) {
                    removedDefect.SecStatus = 0;
                    removedDefect.UsrUpdateID = this.$fun.getUserID();
                    removedDefect.PsgID = this.selectedLoteForModal.id;
                    this.deletedDefects.push(removedDefect);
                }
                
                // Actualizar contadores del lote
                this.selectedLoteForModal.defectCount = this.selectedLoteForModal.defects.length;
                this.selectedLoteForModal.totalWeight = this.selectedLoteForModal.defects
                    .reduce((sum, defect) => sum + defect.PsdWeight, 0).toFixed(2);
                
                // Si no quedan defectos, preguntar si eliminar el lote
                if (this.selectedLoteForModal.defects.length === 0) {
                    this.removeLoteDetail(this.selectedLoteForModal, 'edit');
                    this.removeLoteDetail(this.selectedLoteForModal, 'add');
                    this.showDefectsModal = false;
                    this.$fun.alert("Lote eliminado por no tener defectos", "info");
                } else {
                    this.$fun.alert("Defecto eliminado del lote", "success");
                }
            }
        },
        
        saveRecord() {
            if (this.addForm.TypeCultive == null || this.addForm.TypeCultive == undefined) {
                this.$fun.alert('Debe seleccionar un tipo de cultivo', 'warning');
                return;
            }
            
            if (this.addForm.PchID == null || this.addForm.PchID == undefined) {
                this.$fun.alert('Debe seleccionar un periodo', 'warning');
                return;
            }
            
            const payload = {
                TypeCultive: this.addForm.TypeCultive,
                ClpID: 0,
                PchID: this.addForm.PchID,
                TurnID: this.Turn[0]?.TrnID || null,
                CecID: this.addForm.CecID,
                TypeCut: this.addForm.selectedPeriod?.TypeCut || null,
                PcsTimeBegin: this.addForm.selectedPeriod?.PchDateStart1 || null,
                PcsTimeEnd: this.addForm.selectedPeriod?.PchDateEnd1 || null,
                PcsPpa: this.addForm.PcsPpa,
                PcsPpb: this.addForm.PcsPpb,
                PcsOil: this.addForm.PcsOil,
                UsrCreateID: this.$fun.getUserID(),
                UsrUpdateID: this.$fun.getUserID(),
                FrzProcessSamplingDetail: this.addForm.loteDetails ? this.addForm.loteDetails.map(lot => ({
                    RcfID: lot.RcfID,
                    PsgTotalWeight: parseFloat(lot.totalWeight),
                    PchID: lot.PchID,
                    TypeCultive: lot.TypeCultive,
                    UsrCreateID: this.$fun.getUserID(),
                    UsrUpdateID: this.$fun.getUserID(),
                    FrzProcessSamplingDefects: lot.defects ? lot.defects.map(def => ({
                        DfpID: def.DfpID,
                        PsdWeight: parseFloat(def.PsdWeight),
                        UsrCreateID: this.$fun.getUserID(),
                        UsrUpdateID: this.$fun.getUserID(),
                    })) : []
                })) : []
            };
            
            this.$fun.alert('¿Seguro de guardar el registro?', 'question')
                .then(resp => {
                    if (resp.value) {
                        _sProcessSampling.save(payload, this.$fun.getUserID()).then(r => {
                            if (r.status == 200) {
                                this.$fun.alert("Registro guardado correctamente", "success");
                                this.$refs.sCrudDiscardDevolution.refresh();
                                this.closeAddModal();
                            } else {
                                this.$fun.alert("Error al guardar el registro", "error");
                            }
                        }).catch(error => {
                            console.error("Error al guardar:", error);
                            this.$fun.alert("Error al guardar el registro", "error");
                        });
                    }
                });
        },
        updateRecord() {
            // Combinar lotes activos y eliminados
            const allLotes = [
                // Lotes activos (los que están en editForm.loteDetails)
                ...(this.editForm.loteDetails || []).map(lot => ({
                    PsgID: lot.id,
                    RcfID: lot.RcfID,
                    PsgTotalWeight: parseFloat(lot.totalWeight),
                    PchID: lot.PchID,
                    TypeCultive: lot.TypeCultive,
                    SecStatus: lot.SecStatus ?? 1,
                    UsrCreateID: this.$fun.getUserID(),
                    UsrUpdateID: this.$fun.getUserID(),
                    FrzProcessSamplingDefects: [
                        // Defectos activos del lote
                        ...(lot.defects || []).map(def => ({
                            PsdID: def.PsdID || null,
                            PsgID: lot.id,
                            DfpID: def.DfpID,
                            PsdWeight: parseFloat(def.PsdWeight),
                            SecStatus: def.SecStatus ?? 1,
                            UsrCreateID: this.$fun.getUserID(),
                            UsrUpdateID: this.$fun.getUserID(),
                        })),
                        // Defectos eliminados que pertenecían a este lote
                        ...this.deletedDefects.filter(def => def.PsgID === lot.id)
                    ]
                })),
                // Lotes eliminados completamente
                ...(this.deletedLotes || []).map(lot => ({
                    PsgID: lot.id,
                    RcfID: lot.RcfID,
                    PsgTotalWeight: parseFloat(lot.totalWeight),
                    PchID: lot.PchID,
                    TypeCultive: lot.TypeCultive,
                    SecStatus: 0,
                    UsrCreateID: this.$fun.getUserID(),
                    UsrUpdateID: this.$fun.getUserID(),
                    FrzProcessSamplingDefects: (lot.defects || []).map(def => ({
                        PsdID: def.PsdID || null,
                        PsgID: lot.id,
                        DfpID: def.DfpID,
                        PsdWeight: parseFloat(def.PsdWeight),
                        SecStatus: 0,
                        UsrCreateID: this.$fun.getUserID(),
                        UsrUpdateID: this.$fun.getUserID(),
                    }))
                }))
            ];
            
            const payload = {
                PcsID: this.editForm.PcsID,
                TypeCultive: this.editForm.TypeCultive,
                ClpID: 0,
                PchID: this.itemSelected.PchID,
                CecID: this.itemSelected.CecID,
                TypeCut: this.itemSelected.TypeCut,
                PcsTimeBegin: this.editForm.PcsTimeBegin,
                PcsTimeEnd: this.editForm.PcsTimeEnd,
                PcsPpa: this.editForm.PcsPpa,
                PcsPpb: this.editForm.PcsPpb,
                PcsOil: this.editForm.PcsOil,
                TurnID: this.Turn[0]?.TrnID || null,
                SecStatus: this.itemSelected.SecStatus ?? 1,
                UsrCreateID: this.$fun.getUserID(),
                UsrUpdateID: this.$fun.getUserID(),
                FrzProcessSamplingDetail: allLotes
            };
            
            // console.log("Payload para actualizar:", payload);
            // console.log("Lotes eliminados:", this.deletedLotes);
            // console.log("Defectos eliminados:", this.deletedDefects);
            
            this.$fun.alert('¿Seguro de actualizar el registro?', 'question')
                .then(resp => {
                    if (resp.value) {
                        _sProcessSampling.save(payload, this.$fun.getUserID()).then(r => {
                            if (r.status == 200) {
                                this.$fun.alert("Registro actualizado correctamente", "success");
                                this.$refs.sCrudDiscardDevolution.refresh();
                                this.closeEditModal();
                                this.deletedLotes = [];
                                this.deletedDefects = [];
                            } else {
                                this.$fun.alert("Error al actualizar el registro", "error");
                            }
                        }).catch(error => {
                            console.error("Error al actualizar:", error);
                            this.$fun.alert("Error al actualizar el registro", "error");
                        });
                    }
                });
        },
        
        TurnActive() {
            let TypeArea = 4;
            _sTurnService.turnActive({ TypeArea: TypeArea }, this.$fun.getUserID()).then(r => {
                if (r.status == 200 && r.data && r.data.length > 0) {
                    this.Turn = r.data;
                    const activeTrnID = r.data[0].TrnID;
                    this.filter.TurnID = activeTrnID;
                    this.filter.TrnID = activeTrnID;
                    this.refreshTableData();
                }
            });
        },
        
        inputProdCategory() {
            _sProductionCategory.list(this.$fun.getUserID()).then(r => {
                if (r.status == 200) {
                    this.ProductionCategory = r.data;
                }
            });
        },
        focusNextDefectInput(currentIndex) {
            const nextIndex = currentIndex + 1;
            const nextRef = this.$refs['defectInput' + nextIndex];
            const sText = Array.isArray(nextRef) ? nextRef[0] : nextRef;
            if (sText) {
                const input = sText.$el.querySelector('input');
                if (input) {
                    input.focus();
                }
            }
        },
        calculateTotal() {
            this.$nextTick(() => {
                const ppa = parseFloat(this.addForm.PcsPpa) || 0;
                const ppb = parseFloat(this.addForm.PcsPpb) || 0;
                const total = ppa + ppb;
                
                // Obtener el máximo número de decimales de los inputs
                const ppaDecimals = (this.addForm.PcsPpa.toString().split('.')[1] || '').length;
                const ppbDecimals = (this.addForm.PcsPpb.toString().split('.')[1] || '').length;
                const maxDecimals = Math.max(ppaDecimals, ppbDecimals);
                
                this.addForm.PcsTotal = parseFloat(total.toFixed(maxDecimals));
            });
        },
        calculateTotalEdit() {
            this.$nextTick(() => {
                const ppa = parseFloat(this.editForm.PcsPpa) || 0;
                const ppb = parseFloat(this.editForm.PcsPpb) || 0;
                const total = ppa + ppb;
                
                // Obtener el máximo número de decimales de los inputs
                const ppaDecimals = (this.editForm.PcsPpa.toString().split('.')[1] || '').length;
                const ppbDecimals = (this.editForm.PcsPpb.toString().split('.')[1] || '').length;
                const maxDecimals = Math.max(ppaDecimals, ppbDecimals);
                
                this.editForm.PcsTotal = parseFloat(total.toFixed(maxDecimals));
            });
        },
        getAvailableWeight() {
            const totalUsedWeight = this.addForm.loteDetails.reduce((sum, lote) => {
                return sum + parseFloat(lote.totalWeight || 0);
            }, 0);
            
            return parseFloat(this.addForm.validateWeight || 0) - totalUsedWeight;
        },

        canAddMoreWeight(newWeight) {
            const availableWeight = this.getAvailableWeight();
            return availableWeight >= newWeight;
        },
        getAvailableWeightForEdit() {
            const totalUsedWeight = this.editForm.loteDetails.reduce((sum, lote) => {
                return sum + parseFloat(lote.totalWeight || 0);
            }, 0);
            
            return parseFloat(this.editForm.validateWeight || 0) - totalUsedWeight;
        },

        canAddMoreWeightForEdit(newWeight) {
            const availableWeight = this.getAvailableWeightForEdit();
            return availableWeight >= newWeight;
        },
    },
    
    mounted() {
        this.TurnActive();
    }
}
</script>

<style scoped>
.modern-modal {
    border-radius: 16px !important;
    overflow: hidden;
}

.modal-header {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-content {
    display: flex;
    align-items: center;
}

.header-icon {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    padding: 12px;
    margin-right: 16px;
}

.header-text {
    color: white;
}

.modal-title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    line-height: 1.2;
}

.modal-subtitle {
    font-size: 0.9rem;
    opacity: 0.9;
    margin: 4px 0 0 0;
}

.close-btn {
    background: rgba(255, 255, 255, 0.1) !important;
    backdrop-filter: blur(10px);
}

.modal-body {
    padding: 32px;
    background: #f8f9fa;
}

.progress-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
}

.step {
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0.5;
    transition: opacity 0.3s ease;
}

.step.active {
    opacity: 1;
}

.step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.step.active .step-circle {
    background: #1976d2;
    color: white;
}

.step.completed .step-circle {
    background: #4caf50;
    color: white;
}

.step-divider {
    width: 60px;
    height: 2px;
    background: #e0e0e0;
    margin: 0 16px;
}

.step-label {
    font-size: 0.85rem;
    font-weight: 500;
    color: #666;
}

.step.active .step-label {
    color: #1976d2;
}

.form-section {
    margin-bottom: 2rem;
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
}

.section-icon {
    background: rgba(25, 118, 210, 0.1);
    border-radius: 50%;
    padding: 12px;
    margin-right: 16px;
}

.section-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
}

.section-description {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin: 4px 0 0 0;
}

.form-card, .info-card, .defect-input-card, .registered-lotes-card {
    border-radius: 12px;
    border: 1px solid #e3f2fd;
    background: white;
}

.input-group {
    margin-bottom: 8px;
}

.input-label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #37474f;
    margin-bottom: 8px;
}

.info-item {
    margin-bottom: 16px;
}

.info-label {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 500;
    color: #546e7a;
    margin-bottom: 8px;
}

.info-value {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 4px;
}

.defect-card-title, .registered-card-title {
    background: #f8f9fa;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 16px 24px;
}

.lote-selector {
    background: #f0f4f8;
    border-radius: 8px;
    padding: 16px;
}

.add-lote-btn {
    height: 40px;
    border-radius: 8px;
    font-weight: 500;
}

.defects-title {
    font-size: 1rem;
    font-weight: 600;
    color: #37474f;
    margin-bottom: 16px;
}

.defects-grid {
    display: grid;
    gap: 12px;
}

.defect-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
}

.defect-info {
    display: flex;
    align-items: center;
    flex: 1;
}

.defect-name {
    font-weight: 500;
    color: #37474f;
}

.defect-input {
    width: 120px;
    margin-left: 12px;
}

.modern-table {
    background: transparent;
}

.table-actions {
    display: flex;
    gap: 4px;
}

.empty-state {
    text-align: center;
    padding: 48px 24px;
}

.empty-icon {
    margin-bottom: 16px;
}

.empty-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #37474f;
    margin-bottom: 8px;
}

.empty-description {
    font-size: 0.9rem;
    color: #7f8c8d;
    line-height: 1.5;
}

.modal-footer {
    background: white;
    border-top: 1px solid #e0e0e0;
    padding: 16px 32px;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.cancel-btn {
    font-weight: 500;
}

.save-btn {
    background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
    color: white !important;
    font-weight: 500;
    padding: 0 24px;
    height: 44px;
    border-radius: 8px;
}

.save-btn:disabled {
    background: #e0e0e0 !important;
    color: #9e9e9e !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
    .progress-steps {
        flex-direction: column;
        gap: 16px;
    }
    
    .step-divider {
        width: 2px;
        height: 40px;
        margin: 8px 0;
    }
    
    .modal-body {
        padding: 24px 16px;
    }
    
    .defects-grid {
        grid-template-columns: 1fr;
    }
}

/* Animaciones */
.form-section {
    animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Mejoras de accesibilidad */
.modal-title:focus,
.section-title:focus,
.input-label:focus {
    outline: 2px solid #1976d2;
    outline-offset: 2px;
    border-radius: 4px;
}

.alert-icon {
    background: rgba(244, 67, 54, 0.1) !important;
    animation: pulse-alert 2s infinite;
}
</style>